import apiClient from '../api/client'

const organizadoresService = {
  // Listar todos os organizadores
  async getAll(params = {}) {
    const response = await apiClient.get('/organizadores', { params })
    return response.data
  },

  // Buscar organizador por ID
  async getById(id) {
    const response = await apiClient.get(`/organizadores/${id}`)
    return response.data
  },

  // Criar novo organizador
  async create(data) {
    const response = await apiClient.post('/organizadores', data)
    return response.data
  },

  // Atualizar organizador
  async update(id, data) {
    const response = await apiClient.put(`/organizadores/${id}`, data)
    return response.data
  },

  // Inativar organizador
  async inactivate(id) {
    const response = await apiClient.patch(`/organizadores/${id}/inactivate`)
    return response.data
  },

  // Ativar organizador
  async activate(id) {
    const response = await apiClient.patch(`/organizadores/${id}/activate`)
    return response.data
  },

  // Upload de logo
  async uploadLogo(id, file) {
    const formData = new FormData()
    formData.append('file', file)
    
    const response = await apiClient.post(`/organizadores/${id}/upload-logo`, formData, {
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    })
    return response.data
  },

  // Configurações de Faturamento
  async getConfiguracaoFaturamento(id) {
    const response = await apiClient.get(`/organizadores/${id}/configuracao-faturamento`)
    return response.data
  },

  async updateConfiguracaoFaturamento(id, configuracoes) {
    const response = await apiClient.put(`/organizadores/${id}/configuracao-faturamento`, configuracoes)
    return response.data
  },

  async getConfiguracaoGtaNota(id) {
    const response = await apiClient.get(`/organizadores/${id}/configuracao-gta-nota`)
    return response.data
  },

  async updateConfiguracaoGtaNota(id, config) {
    const response = await apiClient.put(`/organizadores/${id}/configuracao-gta-nota`, config)
    return response.data
  },

  // Pin manual do leilão no catálogo online
  async setCatalogoLeilaoFixado(id, leilaoId) {
    const response = await apiClient.put(`/organizadores/${id}/catalogo-leilao-fixado`, { leilao_id: leilaoId })
    return response.data
  },

  // Dados bancários do organizador
  async getDadosBancarios(id) {
    const response = await apiClient.get(`/organizadores/${id}/dados-bancarios`)
    return response.data
  }
}

export default organizadoresService